firebird.controller('confirmE2EEncryptionKeyCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    'analyticsWrapperService',
    'logService',
    function ($rootScope, $scope, $window, analyticsWrapperService, logService) {
        var self = this;

        self.e2eeKey = '';
        self.modalState = 'closed';
        self.newAttendee = false;
        self.emptyEncryptionKey = false;
        self.invalidEncryptionKey = false;
        self.isSubmitting = false;

        self.leaveMeeting = function () {
            self.modalState = 'closed';
            analyticsWrapperService.eventTrack('Meeting - E2EE - Attendee left encrypted meeting before enter key');
            $rootScope.$broadcast('leave-meeting-without-prompt', { reason: 'e2ee' });
        };

        $window.$('#confirmE2EEncryptionKey').on('shown.bs.modal', function () {
            $window.$('#e2eeConfirmKey').focus();
        });
        self.onInputChange = function () {
            self.emptyEncryptionKey = false;
            self.invalidEncryptionKey = false;
        };

        self.submitE2EE = function () {
            if (self.isSubmitting || self.invalidEncryptionKey || self.emptyEncryptionKey) {
                return;
            }

            const key = (self.e2eeKey || '').trim().substring(0, 16);

            if (key.length === 0) {
                self.e2eeKey = '';
                self.emptyEncryptionKey = true;
                return;
            }

            logService.log('confirmE2EEncryptionKeyCtrl: Submitting key to server');

            self.isSubmitting = true;
            $rootScope.$broadcast('verify-e2ee-hash', {
                e2eeKey: key,
                callback: function (isSuccess) {
                    self.invalidEncryptionKey = !isSuccess;
                    if (isSuccess) {
                        self.modalState = 'closed';
                    }
                    self.isSubmitting = false;
                }
            });
        };

        $scope.$on('e2ee-disabled', function () {
            resetState();
            self.modalState = 'closed';
        });

        $scope.$on('show-modal', function (e, data) {
            if (data.modalName === 'confirmE2EEncryptionKey') {
                resetState();
                self.modalState = 'open';
                self.newAttendee = data.newAttendee;
            }
        });

        function resetState() {
            self.emptyEncryptionKey = false;
            self.invalidEncryptionKey = false;
            self.e2eeKey = '';
        }
    }
]);
